import React from "react";
import { Modal, Button, Text, Group } from "@mantine/core";

interface UploadSuccessModalProps {
  opened: boolean;
  onClose: () => void;
}

const UploadSuccessModal: React.FC<UploadSuccessModalProps> = ({
  opened,
  onClose,
}) => (
  <Modal
    opened={opened}
    onClose={onClose}
    title="File successfully uploaded"
    centered
    size="lg"
  >
    <Text size="sm" mb="md">
      You will receive a confirmation email from our data team shortly. If you
      need further support, please reach out to{" "}
      <Text component="span" className="text-jem-link">
        customersuccess@jemhr.com
      </Text>
      .
    </Text>

    <Group position="right" spacing="sm">
      <Button variant="outline" onClick={onClose}>
        Close
      </Button>
    </Group>
  </Modal>
);

export default UploadSuccessModal;
